import * as CSS from "csstype"
import { system } from "styled-system"

const gridTemplateColumns = system({
  gridTemplateColumns: true,
})

export interface GridTemplateColumnsProps {
  gridTemplateColumns?:
    | CSS.Property.GridTemplateColumns
    | CSS.Property.GridTemplateColumns[]
}

export default gridTemplateColumns
